/** @format */
import config from 'config';
import React from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Link } from 'react-router-dom';
import Image from 'react-bootstrap/Image';
import SimpleImageSlider from 'react-simple-image-slider';
import IconStrip from 'views/Broker/Profile/ObjectListing/IconStrip';
import BrokerProfileHeader from 'views/Broker/Profile/ObjectListing/BrokerProfileHeader';
import MapComponent from 'components/GoogleMapComp';
import { useTranslation } from 'react-i18next';

export default function ObjectListingContents(props) {
  const { t } = useTranslation();
  const {
    tprop,
    priceText,
    imageList,
    objectId,
    noOfBathrooms,
    noOfBedrooms,
    isSwimmingPool,
    coordinates,
    dimensions
  } = props;

  const [key, setKey] = React.useState('Description');

  const viewImagesUrl = `${props.t(
    'lang_route:common_object_view_images'
  )}?objectId=${objectId}`;

  const viewMoreText = t(`lang_common:object_listing.viewMore.text`, {
    count: imageList.length
  });

  const ObjectListing = () => {
    return (
      <div className='object-listing-image-container'>
        <div className='object-listing-primary-image-container'>
          <Image
            rounded
            thumbnail={false}
            src={imageList[0]}
            className='image-primary-image'
          />
        </div>
        <div className='object-listing-secondary-image-container'>
          {imageList.map((item, index) => (
            <React.Fragment key={index}>
              {index >= 1 && index <= 3 && (
                <React.Fragment key={index}>
                  <Image
                    rounded
                    thumbnail={true}
                    src={item}
                    className='image-secondary-image'
                    id={index}
                  />
                  {index >= 3 && (
                    <Link
                      to={viewImagesUrl}
                      className='image-overlay-container'
                      key={index}>
                      <Image
                        rounded
                        thumbnail={true}
                        src={imageList[imageList.length - 1]}
                        className='image-secondary-image'
                        id={index}
                      />
                      <div className='image-overlay'>
                        <span>{viewMoreText}</span>
                      </div>
                    </Link>
                  )}
                </React.Fragment>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    );
  };

  return (
    <>
      <div className='object-listing-image-slider-mobile'>
        <SimpleImageSlider
          width={350}
          height={250}
          images={imageList}
          showBullets={false}
          showNavs={true}
        />
      </div>
      <BrokerProfileHeader {...props} />
      <ObjectListing />
      <Tabs activeKey={key} onSelect={(k) => setKey(k)} className='mb-3'>
        <Tab eventKey='Description' title={tprop.listings.tabs.tab_0.title}>
          <div>
            <p className='text1'>{priceText}</p>
            {tprop.listings.tabs.tab_0.description.map((item, index) => (
              <p key={index} className='text2r'>
                {item.text}
              </p>
            ))}
          </div>
        </Tab>
        <Tab eventKey='RoomsAndFacilities' title='Rooms and Facilities'>
          <IconStrip
            noOfBathrooms={noOfBathrooms}
            noOfBedrooms={noOfBedrooms}
            isSwimmingPool={isSwimmingPool}
            dimensions={dimensions}
          />
        </Tab>
        <Tab eventKey='Location' title='Location'>
          <div style={{ height: '400px', width: '100%' }}>
            <MapComponent
              latitude={parseFloat(coordinates.latitud)}
              longitude={parseFloat(coordinates.longitud)}
              googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${config.app.googleMapsApiKey}&v=weekly`}
              loadingElement={<div style={{ height: `100%` }} />}
              containerElement={<div style={{ height: `400px` }} />}
              mapElement={<div style={{ height: `100%` }} />}
            />
          </div>
        </Tab>
      </Tabs>
    </>
  );
}
